<wbo-edit-page #editPage [title]="model.data.code" (addingAnother)="addingAnother($event)">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.reason-code.edit.formation.details', formControlNames: ''}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                        <wbo-text-edit-control formControlName="code" [(ngModel)]="model.data.code" [readonlyOnEdit]="true">
                        </wbo-text-edit-control>
                        <wbo-entity-discontinued-edit-control
                            formControlName="discontinued"  [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                        </fui-append-field>
                    </fui-column>
                    <fui-column>
                        <wbo-single-select-edit-control formControlName="codeType" [(ngModel)]="model.data.codeType">
                            <wbo-reason-code-type-select-options></wbo-reason-code-type-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description" [(ngModel)]="model.data.description">
                        </wbo-textarea-edit-control>
                    </fui-column>
                    <fui-column *ngIf="Config.REASONS_ALLOW_COMMENTS | booleanConfig">
                        <wbo-checkbox-edit-control formControlName="requiresComment" [(ngModel)]="model.data.requiresComment"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
